import { render, staticRenderFns } from "./iconCloseSession.vue?vue&type=template&id=0a3d5e34&scoped=true"
import script from "./iconCloseSession.vue?vue&type=script&lang=js"
export * from "./iconCloseSession.vue?vue&type=script&lang=js"
import style0 from "./iconCloseSession.vue?vue&type=style&index=0&id=0a3d5e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d5e34",
  null
  
)

export default component.exports